module.exports = "https://web-assets.ifttt.com/packs/media/stencils/calendar-dd96b138.svg";